import type { RewardsPrice } from "@hopper-b2b/types";

/**
 * The flex portion of the trip total, denominated in points.
 *
 * Single source of truth for "trip total in points": the authoritative backend
 * `maximum` from POST /api/v0/pointsToCash/quote, which prices each product at
 * its correct rate. The frontend cash->points estimate is never used.
 *
 * Returns `undefined` while the backend maximum has not loaded yet.
 */
export const getTripTotalInRewards = (
  pointsRedemptionMaximum: number | undefined
): RewardsPrice | undefined =>
  pointsRedemptionMaximum == null
    ? undefined
    : { value: pointsRedemptionMaximum, currency: "Points" };
